import PrivateRouteBase from "commons/components/layout/PrivateRouteBase";

import { RouteType } from "commons/types/route";

import { useAuthContext } from "context/auth";
import { useUserContext } from "context/user";

type PropsType = {
    readonly route: RouteType;
};

function PrivateRoute({ route }: PropsType) {
    const { getAccessToken } = useAuthContext();

    const user = useUserContext();

    return (
        <PrivateRouteBase
            route={route}
            accessToken={getAccessToken()}
            userAuthorities={user.authorities}
            defaultTitle={"Backoffice"}
            cantViewRouteUrl={"/error/unauthorized"}
            useDynamicTitle
            useNavigateBack
        />
    );
}

export default PrivateRoute;
